import React, { useContext, useEffect, useRef, useState } from 'react';
import Styled from 'styled';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';
import classnames from 'classnames';

import { ApiContext, SiteContext, UserStoreContext } from 'four-nets';
import Product from 'four-nets/bazaar/products/product/product';
import { CreateEditProductViewModel } from 'four-nets/bazaar/product/create-edit-product/create-edit-product-view';
import CreateEditProductView from 'four-nets/bazaar/product/create-edit-product/create-edit-product-view';
import { ProductStore, SuperCategoryStore } from 'four-nets/bazaar/bazaar';

import { VendorPresentationFragment } from '../vendor-presentation.graphql';
import defaultStyles from './vendor-products.scss';

type ProductsEdges = NonNullable<NonNullable<VendorPresentationFragment['products']>['edges']>;

interface Props {
    styles: typeof defaultStyles;
    edges: ProductsEdges;
    bazaarProductsCount?: number | null;
    username?: string | null;
}

const VendorProducts: React.FC<Props> = props => {
    const { styles, edges, bazaarProductsCount, username } = props;
    const [viewModel, setViewModel] = useState<typeof CreateEditProductViewModel | null>(null);

    const site = useContext(SiteContext);
    const api = useContext(ApiContext);
    const userStore = useContext(UserStoreContext);

    const stores = useRef<{ categoryStore: null | SuperCategoryStore; productStore: null | ProductStore }>({
        categoryStore: null,
        productStore: null,
    });
    const newProductView = useRef<any>();

    const onNewProductClick = () => {
        if (newProductView.current && viewModel) {
            newProductView.current.show({
                form: viewModel.setupForm(),
            });
        }
    };

    const setNewProductView = (ref: any) => {
        newProductView.current = ref;
    };

    useEffect(() => {
        stores.current = {
            categoryStore: new SuperCategoryStore({ api, userStore }),
            productStore: new ProductStore({ api, userStore }),
        };
        setViewModel(
            new CreateEditProductViewModel({
                productStore: stores.current.productStore,
                superCategoryStore: stores.current.categoryStore,
                site,
            })
        );
    }, [site, api, userStore]);

    return (
        <>
            <div className={styles.heading}>
                <FormattedMessage id='LATEST_SHOP_ENTRIES' /> ({bazaarProductsCount})
            </div>
            <div className={styles.vendorProducts}>
                {edges.length === 0 ? (
                    <FormattedMessage id='ADD_VENDOR_PRODUCTS'>
                        {msg => <span className={styles.description}>{msg}</span>}
                    </FormattedMessage>
                ) : null}
                {edges.map(edge =>
                    edge && edge.node ? (
                        <div className={styles.vendorProduct}>
                            <Product style={{ tile: styles.tile }} {...edge.node} excludeUser={true} />
                        </div>
                    ) : null
                )}
            </div>
            <div className={styles.linkWrapper}>
                <button className={classnames(styles.link, styles.red)} onClick={onNewProductClick}>
                    <FormattedMessage id='BAZAAR_ADD_PRODUCT' />
                </button>
                <Link to={`/market/seller/${username}/`} className={styles.link}>
                    <FormattedMessage id='THE_LATEST_PRODUCTS' />
                </Link>
            </div>
            <CreateEditProductView innerRef={setNewProductView} createEditProductViewModel={viewModel} />
        </>
    );
};

export default Styled(defaultStyles)(VendorProducts);
